// extracted by mini-css-extract-plugin
export default {"toggle":"style_toggle__EUJ3u","toggleMobile":"style_toggleMobile__+eIf9","toggleMobileImg":"style_toggleMobileImg__frfAM"};